import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaEnvelope, FaPhoneAlt, FaHome, FaCopyright } from 'react-icons/fa';

const CopyrightPage = () => {
  return (
    <Container fluid className="bg-light text-dark py-5" style={{ fontSize: '12px' }}>
      <Container>
        <Row>
          <Col>
            <h2 className="text-center text-info mb-4">Copyright Notice</h2>
            <div className="text-start"> {/* Align text to the left */}
              <p>
                This copyright notice governs the use of content related to the services and intellectual property provided by Bandaru Mahesh and the associated brands, including Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy.
              </p>
              <h5>1. Copyright Ownership</h5>
              <p>
                1.1 All content, images, videos, graphics, logos, icons, software, documentation, and other materials displayed on our platforms are the exclusive property of Bandaru Mahesh and the affiliated entities, including Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy.
                <br />
                1.2 Unauthorized use or reproduction of any materials, either digital or physical, constitutes copyright infringement under applicable laws.
              </p>
              <h5>2. Trademarks</h5>
              <p>
                2.1 The trademarks, logos, and service marks ("Marks") displayed on our websites, including those of Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy, are registered and unregistered Marks of Bandaru Mahesh and related entities.
                <br />
                2.2 Use of any Marks without prior written permission is strictly prohibited.
              </p>
              <h5>3. Use of Copyrighted Material</h5>
              <p>
                3.1 Users are granted a limited, non-exclusive, non-transferable, and revocable license to access and view the content for personal use.
                <br />
                3.2 Commercial use, including the resale or distribution of our copyrighted material, is not allowed without explicit permission.
              </p>
              <h5>4. Copyright Infringement</h5>
              <p>
                4.1 In the event of a copyright violation, we reserve the right to take legal action, including seeking damages and other remedies as per the applicable copyright laws.
                <br />
                4.2 Violations may also include but are not limited to the use, reproduction, or alteration of any intellectual property owned by Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy.
              </p>
              <h5>5. Intellectual Property Protection</h5>
              <p>
                5.1 We are committed to protecting our intellectual property rights and those of our partners.
                <br />
                5.2 Any unauthorized use or attempted use of our proprietary materials will be addressed according to legal provisions, including sections related to copyright under the Indian Copyright Act.
              </p>
              <h5>6. User Responsibilities</h5>
              <p>
                6.1 Users are required to respect the intellectual property rights of Bandaru Mahesh and affiliated companies. This includes avoiding unauthorized reproduction, alteration, or distribution of materials.
                <br />
                6.2 In the case of user-submitted content that involves copyrighted material, users must ensure they hold the necessary rights to share the content.
              </p>
              <h5>7. Reporting Copyright Violations</h5>
              <p>
                7.1 If you believe any content on our platforms infringes your copyright, you may report the violation by contacting us at [your.email@example.com].
                <br />
                7.2 Please include detailed information about the alleged infringement, including the material’s location and your contact details for follow-up.
              </p>
              <h5>8. Digital Millennium Copyright Act (DMCA) Compliance</h5>
              <p>
                8.1 In accordance with the Digital Millennium Copyright Act (DMCA), we have implemented procedures for receiving notifications of claimed copyright infringements.
                <br />
                8.2 We will respond promptly to remove or disable access to content that is claimed to be infringing.
              </p>
              <h5>9. License for Educational and Academic Use</h5>
              <p>
                9.1 Educational institutions may use certain materials under a Creative Commons License, subject to approval from Olewin Academy.
                <br />
                9.2 Academic papers, courses, and research material related to Olewin Academy can only be reproduced with proper citation.
              </p>
              <h5>10. Permissions and Licensing</h5>
              <p>
                10.1 For licensing requests or permissions related to the use of our materials, you must contact us at [your.email@example.com].
                <br />
                10.2 Specific permissions will require a licensing agreement outlining terms of use.
              </p>
              <h5>11. Third-Party Content</h5>
              <p>
                11.1 Some content on our websites may belong to third-party sources. Such materials are used under license, and all intellectual property rights remain with the respective owners.
                <br />
                11.2 Unauthorized reproduction of third-party content is strictly prohibited.
              </p>
              <h5>12. Copyright Dispute Resolution</h5>
              <p>
                12.1 Any disputes related to copyright will be handled in accordance with Indian laws, specifically the Copyright Act.
                <br />
                12.2 We encourage parties to attempt resolution through negotiation or mediation before proceeding with legal action.
              </p>
              <h5>13. Copyright Term Duration</h5>
              <p>
                13.1 The copyright for all materials on our websites is valid for the duration as stipulated by applicable copyright laws.
                <br />
                13.2 Upon expiration, certain materials may enter the public domain unless explicitly renewed.
              </p>
              <h5>14. Modification of Content</h5>
              <p>
                14.1 We reserve the right to modify, update, or delete any content, including materials, images, and articles, at our discretion.
                <br />
                14.2 Changes may be made without prior notice to users.
              </p>
              <h5>15. Copyright Notices</h5>
              <p>
                15.1 All official content will bear a copyright notice indicating ownership by Bandaru Mahesh, Olewin, OlewinAI, OlewinTechsolutions, OlewinQ, OlewinTec, and Olewin Academy.
                <br />
                15.2 Removing or obscuring any copyright notice is a violation of these terms.
              </p>
              <h5>16. Open Source Contributions</h5>
              <p>
                16.1 Some software and tools provided by OlewinTec are open-source. Contributions to our open-source projects must adhere to the licensing terms provided in each repository.
                <br />
                16.2 Any contributions made to Olewin open-source projects are subject to review and approval.
              </p>
              <h5>17. Updates to Copyright Notice</h5>
              <p>
                17.1 This copyright notice may be updated periodically to reflect changes in policies or applicable laws.
                <br />
                17.2 Users are encouraged to regularly review this page for any modifications.
              </p>
              <h5>18. Liability for Copyright Infringement</h5>
              <p>
                18.1 In cases of proven copyright infringement, violators may be liable for damages, including legal fees and compensation for losses.
                <br />
                18.2 Such actions will be enforced as per the applicable legal framework.
              </p>
              <h5>19. Governing Law</h5>
              <p>
                19.1 This copyright notice is governed by the laws of India and other applicable international copyright treaties.
                <br />
                19.2 Any disputes shall be resolved in courts located in [Your State/City].
              </p>
              <h5>20. Contact Information</h5>
              <p>
                For inquiries regarding copyright matters, you can reach us at:
                <br />
                <FaEnvelope className="me-1" /> Email:bandarumahesh2024@gmail.com
                <br />
                <FaPhoneAlt className="me-1" /> Phone: +91 8639449423
                <br />
                <FaHome className="me-1" /> Address: Andhra Pradesh, India
              </p>
            </div>
          </Col>
        </Row>
        <hr />
        <Row className="text-center">
          <Col>
            <p>
              <FaCopyright className="me-1" /> {new Date().getFullYear()} Bandaru Mahesh | Olewin | OlewinAI | OlewinTechsolutions | OlewinQ | OlewinTec | Olewin Academy. All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default CopyrightPage;
